import React from 'react';
import TechBackground from './TechBackground';
import ProfessionalBackground from './ProfessionalBackground';
import GeometricBackground from './GeometricBackground';
import TriangleBackground from './TriangleBackground';
import RainbowBackground from './RainbowBackground';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import WallpaperIcon from '@mui/icons-material/Wallpaper';
import WorkIcon from '@mui/icons-material/Work';
import CategoryIcon from '@mui/icons-material/Category';
import ChangeHistoryIcon from '@mui/icons-material/ChangeHistory';
import ColorLensIcon from '@mui/icons-material/ColorLens';
// import TimelineIcon from '@mui/icons-material/Timeline'; // REMOVED
// Import other background components and icons here as needed

// Define the structure for each background option
export const BACKGROUNDS = {
  'blank': {
    id: 'blank',
    name: 'Blank',
    description: 'Plain white background, no effects.',
    component: null, // Represents no background component
    icon: <CheckBoxOutlineBlankIcon />,
  },
  'tech': {
    id: 'tech',
    name: 'Tech Pattern',
    description: 'Subtle animated pattern with tech-related icons.',
    component: TechBackground,
    icon: <WallpaperIcon />,
  },
  'professional': {
    id: 'professional',
    name: 'Professional',
    description: 'A clean and professional background with a focus on structure.',
    component: ProfessionalBackground,
    icon: <WorkIcon />,
  },
  'geometric': {
    id: 'geometric',
    name: 'Geometric',
    description: 'Subtle diagonal lines creating a geometric pattern.',
    component: GeometricBackground,
    icon: <CategoryIcon />,
  },
  'triangle': {
    id: 'triangle',
    name: 'Triangle',
    description: 'Clean triangular shapes at top and bottom of the page.',
    component: TriangleBackground,
    icon: <ChangeHistoryIcon />,
  },
  'rainbow': {
    id: 'rainbow',
    name: 'Rainbow Stripes',
    description: 'Colorful diagonal stripes in the top-right and bottom-left corners.',
    component: RainbowBackground,
    icon: <ColorLensIcon />,
  },
  // 'timeline': { // REMOVED Timeline from here
  //   id: 'timeline',
  //   name: 'Timeline Effect',
  //   description: 'Adds a visual timeline connecting dated sections.',
  //   component: null, // No actual background component, effect is in layout
  //   icon: <TimelineIcon />,
  // },
  // --- Add more background definitions here ---
};

// Helper function to get translated background names
export const getTranslatedBackgroundName = (backgroundId, t) => {
  return t(`backgrounds.${backgroundId}`) || BACKGROUNDS[backgroundId]?.name;
};

// Helper function to get translated background description
export const getTranslatedBackgroundDescription = (backgroundId, t) => {
  return t(`backgrounds.descriptions.${backgroundId}`) || BACKGROUNDS[backgroundId]?.description;
};

// Get all backgrounds as an array
export const getAllBackgrounds = () => {
  return Object.values(BACKGROUNDS);
};

// Get a specific background by ID
export const getBackgroundById = (id) => {
  return BACKGROUNDS[id] || BACKGROUNDS['blank']; // Fallback to blank background
};

// Default background ID
export const DEFAULT_BACKGROUND_ID = 'blank';

// --- REMOVE Default export --- 
/* 
export default {
  getAllBackgrounds,
  getBackgroundById,
  DEFAULT_BACKGROUND_ID,
  BACKGROUNDS,
}; 
*/ 